import {combineReducers} from 'redux';
import Roles from "./Roles/reducers";
import Tiny from "./Tiny/reducers";

const reducers = combineReducers({
  Roles,
  Tiny
});

export default reducers;
